import { render, staticRenderFns } from "./MemberProductLink.vue?vue&type=template&id=88f53450&scoped=true&"
import script from "./MemberProductLink.vue?vue&type=script&lang=js&"
export * from "./MemberProductLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f53450",
  null
  
)

export default component.exports